/**
 * Tabs controller
 * @params options = { tabsCont: '.js-tabs-cont', tabLinks: '.js-tabs-btns', tabPanels: '.js-tabs-panel' }
 * 
 * mockup example
 * <div class="tabs js-tabs-cont">
 *       <div class="tabs__btns js-tabs-btns">
 *           <a class="tabs__btn active">Tab 1</a>
 *           <a class="tabs__btn ">TAB 2</a>
 *       </div>
 *       <div class="tabs__pans">
 *           <div class="tabs__pan js-tabs-panel active">
 *               11111
 *           </div>
 *           <div class="tabs__pan js-tabs-panel">
 *               222222
 *           </div>
 *       </div>
 *   </div>
 * 
 * styles example
 * .tabs {
 *   &__pan {
 *       display: none;
 *       animation: appearAnim 1s;
 *
 *       &.active {
 *           display: block;
 *       }
 *   }
 * }
 *
 * @keyframes appearAnim {
 *    from { opacity: 0; }
 *      to { opacity: 1; }
 * }
 */

import Flickity from 'flickity';

export default class TabsController {
    constructor(options = {}) {
        const defaultOptions = {
            tabsCont: '.js-tabs-cont',
            tabLinks: '.js-tabs-btns a',
            tabPanels: '.js-tabs-panel'
        }

        this.options = {...defaultOptions, ...options};

        //init
        this.init();
    }

    init() {
        const tabCont = document.querySelectorAll(this.options.tabsCont);
        if(!tabCont) return;

        for(let tabs of tabCont) {
            const tabsLinks = tabs.querySelectorAll(this.options.tabLinks);
            const tabPanels = tabs.querySelectorAll(this.options.tabPanels);
    
            if(!tabsLinks || !tabPanels) return;
            
            for(let el of tabsLinks) {
                el.addEventListener("click", e => {
                    e.preventDefault();
        
                    const cont = e.target.closest(this.options.tabsCont);
                    const me = e.currentTarget;
                    const buttonsCont = me.parentElement.children;
                    const activated = cont.querySelectorAll('.active');

                    for(let el of activated) {
                        el.classList.remove('active');
                    }
                    
                    me.classList.add("active");
                    const index = [...buttonsCont].indexOf(me);
                    tabPanels[index].classList.add("active");

                    const newCarousel = new Flickity('.js-products-new-slider');
                    const recomCarousel = new Flickity('.js-products-recom-slider');

                    index === 0 ? newCarousel.resize() : recomCarousel.resize();


                    //restart svg-draw animation
                    if(this.options.ref && this.options.ref.restartAnim) {
                        this.options.ref.restartAnim();
                    }
                });
            }
        }
    }
}